module.exports = __webpack_public_path__ + "img/ind_other.e7b720d4.png";